import { Sparkles } from "lucide-react";

export const PromptPanel = ({ prompt, onChange, onSubmit, disabled }) => (
    <div className="border border-white/10 bg-surface p-5">
        <label className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/60 flex items-center gap-2 mb-3">
            <Sparkles className="w-3 h-3 text-blaze" />
            Transformation Prompt
        </label>
        <textarea
            value={prompt}
            onChange={onChange}
            rows={4}
            placeholder="Describe what you want to become..."
            className="w-full bg-obsidian border border-white/10 text-white px-3 py-3 focus:border-electric focus:ring-1 focus:ring-electric outline-none resize-none font-mono text-xs placeholder:text-white/20 transition-all"
            data-testid="prompt-textarea"
        />
        <button
            onClick={onSubmit}
            disabled={disabled}
            className="mt-3 w-full bg-transparent border border-white/20 hover:border-white/60 disabled:opacity-30 disabled:cursor-not-allowed text-white font-mono uppercase text-[11px] tracking-[0.25em] py-2.5 transition-colors"
            data-testid="apply-prompt-button"
        >
            Apply to Live Stream →
        </button>
    </div>
);
